// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-rating ion-toolbar{z-index:0}.filter-rating ion-range{padding-top:0}", ""]);
// Exports
module.exports = exports;
